import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { WebsiteContent } from '../../types';
import defaultContent from '../../data/defaultContent.json';

interface ContentState {
  content: WebsiteContent;
  loading: boolean;
  error: string | null;
  lastUpdated: string | null;
}

const initialState: ContentState = {
  content: defaultContent as unknown as WebsiteContent,  // ✅ fixed type assertion
  loading: false,
  error: null,
  lastUpdated: null,
};

export const fetchContent = createAsyncThunk(
  'content/fetchContent',
  async () => {
    // In production, this would fetch from your API
    // const response = await axios.get('/api/content');
    // return response.data;
    
    // For now, return default content
    return defaultContent as unknown as WebsiteContent;  // ✅ fixed type assertion
  }
);

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    updateContent: (state, action: PayloadAction<WebsiteContent>) => {
      state.content = action.payload;
      state.lastUpdated = new Date().toISOString();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContent.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload;
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(fetchContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch content';
      });
  },
});

export const { updateContent } = contentSlice.actions;
export default contentSlice.reducer;